import { getCurrentScene, setEraserTrash, setPressingMode, updateScene } from "../../../redux/actions/canvas/canvas";
import store from "../../../redux/store";
import { addCommand } from '../../history/HistoryService';
import { clone } from "../../../utils/clone";
export var start = function (event) {
    setPressingMode(true);
};
export var move = function (event) { };
export var finish = function (event) {
    var eraserTrashCan = store.getState().canvas.eraserTrashCan;
    setPressingMode(false);
    // Удаляем элементы
    var scene = getCurrentScene();
    if (scene && eraserTrashCan.length > 0) {
        // Сохраняем удаленные элементы для возможности отката
        var deletedItems = {
            curves: scene.curves.filter(function (item) { return eraserTrashCan.includes(item.id); }),
            images: scene.images.filter(function (item) { return eraserTrashCan.includes(item.id); }),
            lines: scene.lines.filter(function (item) { return eraserTrashCan.includes(item.id); }),
            notes: scene.notes.filter(function (item) { return eraserTrashCan.includes(item.id); }),
            shapes: scene.shapes.filter(function (item) { return eraserTrashCan.includes(item.id); })
        };
        console.log('Ластик: eraserTrashCan:', eraserTrashCan);
        console.log('Ластик: удаляем элементы:', deletedItems);
        // Добавляем команду в историю перед удалением
        addCommand('DELETE_ITEMS', { deletedItems: clone(deletedItems) });
        // ВАЖНО: Получаем сцену заново после addCommand(),
        // потому что addCommand() уже обновила сцену в Redux
        scene = getCurrentScene();
        // Удаляем элементы
        scene.curves = scene.curves.filter(function (item) { return !eraserTrashCan.includes(item.id); });
        scene.images = scene.images.filter(function (item) { return !eraserTrashCan.includes(item.id); });
        scene.lines = scene.lines.filter(function (item) { return !eraserTrashCan.includes(item.id); });
        scene.notes = scene.notes.filter(function (item) { return !eraserTrashCan.includes(item.id); });
        scene.shapes = scene.shapes.filter(function (item) { return !eraserTrashCan.includes(item.id); });
        updateScene(scene);
        setTimeout(function () { setEraserTrash([]); }, 0);
    }
};
